import { SxProps, Theme } from '@mui/material';

export const FallbackUIMainStyles: SxProps<Theme> = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
  paddingBottom: theme => theme.spacing(4),
  paddingTop: theme => theme.spacing(12),
  width: '100%',
};

export const FallbackUIPaperStyles: SxProps<Theme> = {
  borderRadius: theme => theme.spacing(0.75),
  boxShadow: theme => theme.variables.boxShadowMenu,
  padding: theme => theme.spacing(4),
};

export const FallbackUIMessageStyles: SxProps<Theme> = {
  fontSize: 20,
  marginBottom: theme => theme.spacing(2),
};

export const FallbackUITitleStyles: SxProps<Theme> = {
  '& svg': {
    '& path': {
      fill: theme => theme.colors.redPink,
    },
    alignSelf: 'center',
    fontSize: theme => theme.spacing(4.5),
    marginRight: theme => theme.spacing(1.5),
  },
  display: 'flex',
  fontSize: 24,
  justifyContent: 'center',
};

export const FallbackUISeparatorStyles: SxProps<Theme> = {
  backgroundColor: theme => theme.colors.silver,
  height: 2,
  marginBottom: theme => theme.spacing(3),
  marginTop: theme => theme.spacing(3),
  opacity: 0.7,
  width: '100%',
};

export const FallbackUIInstructionStyles: SxProps<Theme> = {
  '& svg': {
    '& path': {
      fill: theme => theme.colors.darkSkyBlue,
      stroke: 'white',
    },
    fontSize: theme => theme.spacing(6),
    marginLeft: -10,
    marginRight: theme => theme.spacing(0.5),
    marginTop: 2,
  },
  alignItems: 'center',
  display: 'flex',
  fontSize: theme => theme.spacing(1.75),
  marginTop: theme => theme.spacing(4),
};
